import styled from "styled-components";
import RqBackground from '../../assets/images/rq-background.png';

export const Page = styled.div`
    padding: 0 ${ props => props.theme.spacing.main };
    display: flex;
    flex-direction: column;
    font-family: var(--font-gotham);
    min-height: 100vh;
    background-image: url(${RqBackground});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    position: relative;
    
    /* Dark overlay for better text readability */
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 0;
        pointer-events: none;
    }
    
    /* Ensure all content appears above the overlay */
    > * {
        position: relative;
        z-index: 1;
    }
    
    /* input {
        width: 100%;
    } */

    .inputWrapper {
        margin-top: 70px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .termsConditions {
        color: #FFF;
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
    }
    a {
        color: #E6D2A6;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
        letter-spacing: 0.14px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        text-transform: capitalize;
    }

    .technicalErrorMessage {
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 24px;
        font-style: normal;
        font-weight: 900;
        line-height: 120%; /* 28.8px */
        text-transform: capitalize;
        margin-top: 90px;
        margin-bottom: ${ props => props.theme.spacing.main };
    }

    .winner.elimination {
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
    }

    .offlineMessage {
        margin-bottom: ${ props => props.theme.spacing.main };
    }

    .mrBottomEtraLarge {
        margin-bottom: ${ props => props.theme.spacing.extraLarge };
    }
    .mrBottomLarge {
        margin-bottom: ${ props => props.theme.spacing.large };
    }
    
    .mrBottomMain {
        margin-bottom: ${ props => props.theme.spacing.main };
    }

    .mrBottomSmall {
        margin-bottom: ${ props => props.theme.spacing.small };
    }

`;